import type { Event, EventHint } from "@sentry/types";

const chunkLoadError = (event: Event, hint: EventHint): Event | null => {
  const chunkLoadErrorString = "ChunkLoadError";
  // Optional chaining required: Webpack/RSpack bundles provide import.meta as an
  // empty object (import.meta.env is undefined). Remix/Vite populates it normally.
  // Safe to remove the ?. once all packs are migrated off Webpack.
  const assetBaseUrl = import.meta.env?.BASE_URL;
  const error = hint.originalException as Error | string;

  const isChunkLoadingString = typeof error === "string" && error.includes(chunkLoadErrorString);
  const isChunkLoadingError =
    typeof error !== "string" && error?.name?.includes(chunkLoadErrorString);

  // Vite produces a TypeError whose message contains the failing asset URL.
  // Matching on the asset base path (from Vite's `base` config) is browser-agnostic
  // and stays in sync with the build config automatically.
  // In Webpack, import.meta.env is undefined so these checks are skipped.
  const isStaleAssetString =
    typeof assetBaseUrl === "string" &&
    typeof error === "string" &&
    error.includes("TypeError") &&
    error.includes(assetBaseUrl);
  const isStaleAssetError =
    typeof assetBaseUrl === "string" &&
    typeof error !== "string" &&
    error instanceof TypeError &&
    error?.message?.includes(assetBaseUrl);

  if (isChunkLoadingString || isChunkLoadingError || isStaleAssetString || isStaleAssetError) {
    return null;
  }

  return event;
};

export { chunkLoadError };
